import { render, staticRenderFns } from "./MoveBEModal.vue?vue&type=template&id=6c816d80"
import script from "./MoveBEModal.vue?vue&type=script&lang=js"
export * from "./MoveBEModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports